import { CombinedCustomerInfo } from '../../../../../interfaces/Customer';
import { UserProfileFromValue } from '../UserProfileStep.settings';

export const getUserProfileFromValue = async (
  info: CombinedCustomerInfo | null,
): Promise<UserProfileFromValue> => {
  if (!info) {
    throw new Error('Customer info is not loaded');
  }

  const { customer, user, inbodyInfo, additionallyInfo, customerGroup } = info;

  const defaultScanData = {
    height: customer.height,
  } as UserProfileFromValue['scanData'];

  return {
    customer,
    user,
    inbodyInfo,
    additionallyInfo,
    customerGroup: customerGroup || null,
    scanData: defaultScanData,
  };
};
